import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";

const MyLabel = ({ name, title, required }) => {
  return (
    <>
      <Label className=" " htmlFor={name}>
        {title}
        {title && required && <Required />}
      </Label>
    </>
  );
};

export default MyLabel;
